import React, { useEffect, useState } from "react";
import { fetcherVideosPreview } from "../../../DataFetchers/VideosPreviewFetcher";
import { VideosPreviewSwiper } from "./VideosPreviewSwiper";
import { VideosPreviewType } from "@infrastructure/Services/VideosPreviewService";
import { PostDetailsActionType } from "../../Modals/PostDetailsModal/PostDetailsModalStore";
import { useInView } from "@infrastructure/Hooks/useInView";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import { useGroupSelector } from "../../GroupSelector/useGroupSelector";
import { ContainerStack, SectionTitle } from "./VideoSwiperContainer.styles";

export function VideoSwiperContainer({
    groupId,
    onPostCardClick,
}: {
    groupId: string;
    onPostCardClick: (postId: string, action?: PostDetailsActionType) => void;
}) {
    const { getConfigs } = useGlobalConfigs();
    const [previews, setPreviews] = useState<VideosPreviewType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { ref, inView } = useInView(true);
    const { preparedFiltersForPost } = useGroupSelector();

    useEffect(() => {
        if (inView) {
            fetcherVideosPreview(groupId, { ...preparedFiltersForPost }).then(
                (videos) => {
                    setPreviews(videos);
                    setIsLoading(false);
                },
            );
            return () => {
                setPreviews([]);
                setIsLoading(true);
            };
        }
    }, [groupId, inView, preparedFiltersForPost]);

    if (!getConfigs()?.tippspielFeedVideoGalleryEnabled) {
        return null;
    }

    if (!isLoading && !previews.length) {
        return null;
    }

    return (
        <ContainerStack ref={ref}>
            <SectionTitle>Stories entdecken</SectionTitle>
            <VideosPreviewSwiper
                previews={previews}
                onPostCardClick={onPostCardClick}
                isLoading={isLoading}
            />
            {/* HOTF-5482 - Hidden for now until we implement the modal */}
            {/*<Stack*/}
            {/*    direction={"row"}*/}
            {/*    alignSelf={"end"}*/}
            {/*    justifyContent={"center"}*/}
            {/*    marginBottom={"16px"}*/}
            {/*    marginTop={"8px"}*/}
            {/*    gap={"8px"}*/}
            {/*>*/}
            {/*    <TippspielLinkTypography>*/}
            {/*        Alle Reels anzeigen*/}
            {/*    </TippspielLinkTypography>*/}
            {/*    <ChevronRegularRightIcon*/}
            {/*        color={"rgb(0, 94, 168)"}*/}
            {/*        width={"12px"}*/}
            {/*        height={"12px"}*/}
            {/*        alignSelf={"center"}*/}
            {/*    />*/}
            {/*</Stack>*/}
        </ContainerStack>
    );
}
